import { render } from "./LegacyApp.vue?vue&type=template&id=939b78ca"
import script from "./LegacyApp.vue?vue&type=script&lang=js"
export * from "./LegacyApp.vue?vue&type=script&lang=js"
script.render = render

export default script